module.exports = __webpack_public_path__ + "static/media/trademark.cb57f0ed.svg";